<template>
  <div class="new-journal">
    <HeaderNewCopy />
    <!-- Desktop -->
    <div class="pc consult-page">
      <div class="main">
        <div class="main-info">
          <h1 class="title">Получите финансовую консультацию в чате <br />
            с нашими экспертами</h1>
          <div class="message-img">
            <p class="message">
              Задайте нам любые вопросы, связанные с финансами - начиная с того, как правильно экономить, и заканчивая
              тем, как улучшить кредитную историю. Мы поможем вам разобраться, чтобы вы могли быть уверены в своей
              финансовой грамотности.
            </p>
          </div>
          <ButtonAction class="main-action-btn" type="submit" message="Получить консультацию"
            @buttonAction="getConsult" />
        </div>
        <img class="elements-img" src="@/assets/img/consult-img.png" alt="phone elements">
      </div>
      <div class="full-width">
        <div class="benefits">
          <div class="info">
            <h2 class="sub-title">Решите ваш вопрос прямо сейчас</h2>
            <ButtonAction class="main-action-btn" type="submit" message="Получить консультацию"
              @buttonAction="getConsult" />
          </div>
          <div class="cards">
            <div class="card_consult">
              <img src="@/assets/img/icon-comfy.svg" alt="comfy icon">
              <h4 class="card-title">Удобно</h4>
              <p class="text">Получите ответ на свой вопрос в телеграм-чате, переписка всегда будет у вас под рукой.</p>
            </div>
            <div class="card_consult">
              <img src="@/assets/img/icon-simple.svg" alt="simple icon">
              <h4 class="card-title">Просто</h4>
              <p class="text">Донесем информацию доступно и понятно, без сложных терминов и неоднозначных деталей.</p>
            </div>
            <div class="card_consult">
              <img src="@/assets/img/icon-profitable.svg" alt="profitable icon">
              <h4 class="card-title">Выгодно</h4>
              <p class="text">Получите качественный ответ от специалиста в области финансов всего за 499 рублей.</p>
            </div>
          </div>
        </div>
      </div>

      <div class="faq">
        <h2 class="sub-title">FAQ</h2>
        <div class="questions">
          <div class="item">
            <div class="item-head" @click="() => showQuestion(99)">
              <h5 class="title">Что мне нужно сделать, чтобы получить консультацию?</h5>
              <div class="img" :class="{ active: (currentFaq === 99) }">
              </div>
            </div>
            <p class="text" :class="{ active: (currentFaq === 99) }">Просто задайте свой вопрос в нашем телеграм-боте.
              Для этого перейдите <a href="https://t.me/Finsite_bot">по ссылке</a>, нажмите кнопку 'Начать' и задайте
              свой вопрос </p>
          </div>
          <div v-for="(item, index) in questions" :key="item.id" class="item">
            <div class="item-head" @click="() => showQuestion(index)">
              <h5 class="title">{{ item.title }}</h5>
              <div class="img" :class="{ active: (currentFaq === index) }">
              </div>
            </div>
            <p class="text" :class="{ active: (currentFaq === index) }">{{ item.text }} </p>
          </div>
        </div>
      </div>
    </div>

    <!--Mobile -->
    <div class="phone consult-page">
      <div class="main">
        <h1 class="title">Получите финансовую консультацию <br>в чате
          с нашими экспертами</h1>
        <img class="elements-img" src="@/assets/img/consult-img.png" alt="phone elements">
        <div class="main-info">
          <div class="message-wrapper">
            <p class="message">
              Задайте нам любые вопросы, связанные <br />
              с финансами. Мы поможем вам <br /> разобраться, чтобы вы могли быть уверены <br /> в своей финансовой
              грамотности.
            </p>
          </div>
          <ButtonAction class="main-action-btn" type="submit" message="Получить консультацию"
            @buttonAction="getConsult" />
        </div>
      </div>
      <div class="full-width">
        <div class="benefits">
          <h2 class="sub-title">Делаем все для повышения вашей финансовой грамотности</h2>
          <div class="cards">
            <div class="card_consult">
              <img src="@/assets/img/icon-comfy.svg" alt="comfy icon">
              <div class="card-info">
                <h4 class="card-title">Удобно</h4>
                <p class="text">Получите ответ на свой вопрос <br>в телеграм-чате, переписка всегда будет у вас под рукой.
                </p>
              </div>
            </div>
            <div class="card_consult">
              <img src="@/assets/img/icon-simple.svg" alt="simple icon">
              <div class="card-info">
                <h4 class="card-title">Просто</h4>
                <p class="text">Донесем информацию доступно и понятно, без сложных терминов и неоднозначных деталей.</p>
              </div>
            </div>
            <div class="card_consult">
              <img src="@/assets/img/icon-profitable.svg" alt="profitable icon">
              <div class="card-info">
                <h4 class="card-title">Выгодно</h4>
                <p class="text">Получите качественный ответ от специалиста в области финансов всего за 499 рублей.</p>
              </div>
            </div>
          </div>
          <ButtonAction class="main-action-btn" type="submit" message="Получить консультацию"
            @buttonAction="getConsult" />
        </div>
      </div>

      <div class="faq">
        <h2 class="sub-title">FAQ</h2>
        <div class="questions">
          <div class="item">
            <div class="item-head" @click="() => showQuestion(99)">
              <h5 class="title">Что мне нужно сделать, чтобы получить консультацию?</h5>
              <div class="img" :class="{ active: (currentFaq === 99) }">
              </div>
            </div>
            <p class="text" :class="{ active: (currentFaq === 99) }">Просто задайте свой вопрос в нашем телеграм-боте.
              Для этого перейдите <a href="https://t.me/Finsite_bot">по ссылке</a>, нажмите кнопку 'Начать' и задайте
              свой вопрос </p>
          </div>
          <div v-for="(item, index) in questions" :key="item.id" class="item">
            <div class="item-head" @click="() => showQuestion(index)">
              <h5 class="title">{{ item.title }}</h5>
              <div class="img" :class="{ active: (currentFaq === index) }">
              </div>
            </div>
            <p class="text" :class="{ active: (currentFaq === index) }">{{ item.text }} </p>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import HeaderNewCopy from '@/components/newRedesign/HeaderNewCopy.vue';
import Footer from '@/components/newRedesign/FooterNewCopy.vue';
import ButtonAction from "@/components/newRedesign/UI/ButtonAction";

export default {
  name: 'Consultations',
  data: () => {
    return {
      currentFaq: -100,
      questions: [
        {
          id: 2, title: "Как долго занимает получение консультации?",
          text: "Мы ответим на ваш запрос в течение 24 часов. Общий срок консультации будет зависеть от сложности вашего вопроса, а также от скорости предоставления вами дополнительной информации, если она понадобится. Со своей стороны мы прилагаем все усилия, чтобы дать вам полноценную консультацию за короткий срок."
        },
        {
          id: 3, title: "Какова стоимость консультации?",
          text: "Стоимость консультации составит 499 рублей. Вы сможете совершить безопасную оплату с вашей банковской карты."
        },
        {
          id: 4, title: "Кто предоставляет консультации?",
          text: "Ответы на ваши вопросы дают наши специалисты с финансовым образованием и опытом работы в этой сфере. Перед началом работы кандидаты проходят тщательный отбор и тестирование знаний. Но спешим вам напомнить, что все ответы консультанта носят исключительно рекомендательный характер и нацелены на оказание помощи пользователям сервиса в получении необходимой справочной информации. Администрация сервиса не несет ответственности за убыток или ущерб, включая, в частности, любую утрату выгоды, которая может являться прямым или косвенным результатом использования или принятия во внимание такой информации."
        },
        {
          id: 5, title: "Что будет, если мне не понравится консультация?",
          text: "Мы прилагаем все усилия, чтобы дать максимально развернутый и полезный ответ на ваш вопрос. Каждый случай уникален, и если мы по каким-то причинам не смогли решить ваш запрос, мы вернем вам деньги за предоставленную консультацию."
        },
      ]
    }

  },
  components: {
    HeaderNewCopy,
    Footer,
    ButtonAction
  },
  methods: {
    showQuestion(faq) {
      if (faq === this.currentFaq) {
        this.currentFaq = -100
      } else {
        this.currentFaq = faq
      }
    },
    getConsult() {
      window.open('https://t.me/Finsite_bot', '_blank');
    }
  }
}

</script>
<style scoped lang="scss">
.consult-page {
  width: 1232px;
  margin-right: auto;
  margin-left: auto;
  margin-top: 73px;

  .main {
    display: flex;
    padding: 70px 0 165px;
    position: relative;

    .main-info {
      width: 520px;

      .title {
        padding: 0;
        margin-bottom: 30px;
        font-weight: 600;
        font-size: 48px;
        line-height: 57px;
        color: #333333;
      }

      .message-img {
        background-image: url("../../../assets/img/message-frame.png");
        background-size: cover;
        margin-top: -20px;
        margin-left: -20px;
        margin-right: -20px;
        margin-bottom: 20px;
        height: 192px;
        position: relative;
      }

      .message {
        position: absolute;
        top: 32px;
        left: 40px;
        width: 481px;
        font-weight: 400;
        font-size: 18px;
        line-height: 21px;
        color: #333333;
        // border-radius: 12px;
        // box-shadow: 0px 2px 4px rgba(12, 98, 77, 0.25), 0px 4px 20px rgba(34, 180, 145, 0.5);
      }
    }

    .elements-img {
      width: 642px;
      position: absolute;
      right: -20px;
      top: 16%;
    }
  }

  .full-width {
    width: 100vw;
    margin-left: calc((100vw - 1232px) / -2);
    background-color: #F5F5F5;
    padding: 70px 0;
    border-radius: 12px;

    .benefits {
      width: 1232px;
      margin: auto;
      display: flex;
      justify-content: space-between;
      align-items: end;

      .info {
        margin-right: 24px;

        .sub-title {
          margin-bottom: 75px;
          font-weight: 600;
          font-size: 32px;
          line-height: 38px;
          color: #333333;
        }
      }

      .cards {
        display: flex;

        .card_consult {
          width: 296px;
          padding: 30px 10px 40px 20px;
          margin-right: 16px;
          border-radius: 12px;
          background-color: #fff;

          img {
            width: 50px;
            height: 50px;
            margin-bottom: 32px;
          }

          .card-title {
            padding: 0;
            margin-bottom: 20px;
            font-weight: 600;
            font-size: 20px;
            line-height: 24px;
            color: #2F80ED;
          }

          .text {
            font-weight: 400;
            font-size: 16px;
            line-height: 20px;
            color: #333333;
          }
        }

        .card_consult:last-child {
          margin-right: 0;
        }
      }
    }
  }

  .faq {
    display: flex;
    justify-content: space-between;
    padding: 125px 0 123px;

    .sub-title {
      font-weight: 600;
      font-size: 32px;
      line-height: 38px;
      display: flex;
      color: #333333;
    }

    .questions {
      .item {
        width: 920px;
        position: relative;
        padding-top: 17px;

        .item-head {
          display: flex;
          justify-content: space-between;
          align-items: center;
          cursor: pointer;

          .title {
            margin: 0;
            padding: 0;
            font-weight: 500;
            font-size: 26px;
            line-height: 31px;
            color: #333333;
          }

          .img {
            display: block;
            width: 24px;
            height: 24px;
            background-image: url("../../../assets/img/faq-plus.svg");
            background-size: cover;
            background-position: center;
            cursor: pointer;
            transition: all 0.3s ease-in-out;
          }

          .img.active {
            background-image: url("../../../assets/img/faq-minus.svg");
          }
        }

        .text {
          width: 816px;
          max-height: 0;
          padding-top: 0px;
          font-weight: 400;
          font-size: 16px;
          line-height: 20px;
          color: #333333;
          overflow: hidden;
          transition: all 0.3s ease-in-out;
        }

        .text.active {
          max-height: 150px;
          padding-top: 13px;
        }
      }

      .item:first-child {
        padding-top: 0px;
      }
    }
  }
}
</style>

<style scoped lang="scss">
.consult-page.phone {
  width: 289px;

  .main {
    display: block;
    padding: 93px 0 30px;

    .title {
      font-weight: 600;
      font-size: 27px;
      line-height: 30px;
      margin-bottom: 24px;
      padding: 0;
    }

    .elements-img {
      width: 289px;
      position: relative;
      right: 0;
    }

    .main-info {
      width: 100%;
      padding-top: 32px;

      .message-wrapper {
        margin-bottom: 10px;

        .message-img {
          background-image: none;
          width: 100%;
        }

        .message {
          position: relative;
          top: 0;
          left: 0;
          width: 288px;
          padding: 0;
          margin-bottom: 0;
          font-size: 14px;
          line-height: 17px;
        }
      }
    }
  }

  .full-width {
    margin-left: calc((100vw - 289px) / -2);
    padding-top: 10px;
    padding-bottom: 30px;

    .benefits {
      width: 289px;
      margin: auto;
      display: block;

      .sub-title {
        font-weight: 600;
        font-size: 23px;
        line-height: 28px;
        margin-bottom: 20px;
      }

      .cards {
        display: block;

        .card_consult {
          display: flex;
          flex-direction: row;
          width: 289px;
          padding: 20px 15px 20px 10px;
          margin-bottom: 20px;

          img {
            width: 30px;
            height: 30px;
            margin: 0 10px 0 0;
          }

          .card-info {
            .card-title {
              margin-bottom: 10px;
              font-size: 16px;
              line-height: 19px;
            }

            .text {
              font-size: 14px;
              line-height: 18px;
            }
          }
        }
      }
    }
  }


  .faq {
    display: block;
    padding: 26px 0 43px;

    .sub-title {
      font-size: 24px;
      line-height: 28px;
      margin-bottom: 27px;
    }

    .questions {
      .item {
        width: 100%;

        .item-head {
          align-items: normal;

          .title {
            font-size: 17px;
            line-height: 20px;
            width: 260px;
          }

          .img {
            width: 20px;
            height: 20px;
          }
        }

        .text {
          width: 100%;
          font-size: 12px;
          line-height: 15px;
        }

        .text.active {
          max-height: 250px;
        }
      }
    }
  }
}
</style>
